var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _image, _g63, _image2, _g64, _image3, _g65, _image4, _g66, _image5, _g67, _image6, _g68, _image7, _g69, _image8, _g70, _image9, _g71, _image0, _g72, _image1, _g73, _image10, _g74, _g75, _image11, _g76, _image12, _g77, _image13, _g78, _image14, _g79, _image15, _g80, _image16, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _image17, _g111;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1120px",
    height: "480px",
    viewBox: "-0.5 -0.5 1120 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(\"https://fonts.googleapis.com/css?family=Ubuntu+Mono\");&#xa;@import url(\"https://fonts.googleapis.com/css?family=Ubuntu\");"), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1120,
    height: 480,
    fill: "#192740",
    stroke: "none",
    pointerEvents: "all"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-4"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-6"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-8"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-9"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-12"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-13"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-14"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-15"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-23"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-24"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-26"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-27"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-28"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-29"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-30"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-31"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-32"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-33"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-34"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-35"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-36"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-37"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-38"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-39"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-40"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-41"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-42"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-43"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-44"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-45"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-46"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-47"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-48"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-49"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-50"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-51"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-52"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-53"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-54"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-55"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-56"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-57"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-61"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "A_SkYgq9qc6-LE0gNnWI-62"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-1"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-2"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-3"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-4"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-5"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-6"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-11"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-12"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "9l5qiDt3rFkPDL6V6DHt-13"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-5"
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 120,
    width: 80,
    height: 80,
    fill: "#a3ea2a",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #192740; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(25, 39, 64)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "A")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 181,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABPNJREFUeF7tm0uIHEUYx//fbOKKD3BCVrc3WUEJ2xMNKK6e1EwPGky8avCgiUGCijnoQQ8iGl94URAUXwcJJOAh8eor4E4P8SSKj2CY3iSwhuz0uigGH0jMzpT0ZI2zM9VdvSn7kvrPcer7auhf/ejq6X+3gB8SKJCAFDg3pyYBUDBKUCgBClYoXk5OwehAoQQoWKF4OTkFowOFEqBgheLl5BSMDhRKgIIVipeTUzA6UCgBClYoXk5OwTIc8PzgUQDvZGkiIve3mvUPqJKeAAXLFuxjAFsyBYPa34oa91EwCrYsB0auCy5b0cbPAIYNjb+Xh0ZWHzly4O9l/YAjxTyDpSz0qB/cK8CBXB6IbI6b9c9y1TpWRMFSFtzzg30AHsjjg0C93Yoau/LUulZDwbQrvnXI8+fnAVm1dFidAORqTcvJOArHXZMnz/FSMA2l0UoQiEJdM/QsgORMNTowJnJz3Kx/nQe6SzUUTLPanh+8DuCJ/iHpYBNK8rCC2jrYJi/FUf05l+TJc6wUTCtY9Tgg1/Ztj53T7UvKF6/4a7tSeFPT9l0chTfmge5SDQXrW+2r1gcbSh0cHpBA4Yd4OtywZqJ2Q0fUtzpJlOCauWY445JApmOlYH2EPD94BsDLGnDvx1G4E9hd8vzGLwCu0GyTj8dR/Q0TdJfGKdigYF8CuGXg+gvqoVbU2JN87/nVjwC5W1Mz1Yoad7gkkOlYKVgPodXrb/dWdoZmgcG3rdrt0rr5Y1PHu4JVqk9DySsauAvDpzEyMxOeMoF3ZZyC9ay0VwkegcK7msWfjaNw7b/fj/m1WxXUFzpJGH4vpULBegXzg5RwW/bFUX37udLJyZXeH5f/CuBSzTbJ8LsHCgVbhJEVbislD85N1/f2yuT5wScANmvOYgy/KdigFlnhdqmN8dlj4cnertFK8KQovKq9lpLSXXFz6qAr11lZx8kz2CIdz6/tBdQ2DayjcRRO9H/vVWqTUOor7XUYw+9zWChYF0VauN0dfC+OwuTJ1r5P935Y8rxYWSMZw+9FKBQsSa7Tw+3z3+UYfnfZUbDujVN9uH3+dgEi6sVWs7HbZo4LoZeCnb0zrwm3rZeX4TfPYEBquG3tF8Dwm1tksj2mhdv/g2LifPjt/Bbp+YE23AagFLDfZJkAawDcpqtTwOdzUXinaY4LedxpwbLCbQi+iZvhTabFX3t9sK69gKMpdc6H304LlhFuJ3+vX2tF4VMmwZJxz6/+mPIyCFwPv90WLDXc7mq1JY7CT/MINjYR7FGCHSl39Z0Ov50VLDPcBs6o4YvKP31/8M88gnkT1W0QWRKG/9enfisPXTni6pvfzgrmVWr3QKkPUwQ6FEfhxjxyJTXj/qaxBZxJHlTUfxwOv90VLD3cTv4+Pj83Hb6QV7Cz12FBE4Cfsk06++a3o4JlhtvJDYqN8XTj0HIEG/OrbynIYyk9zobfjgq2HHVYa0OAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJEDBjIhYYEOAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJEDBjIhYYEOAgtnQY6+RAAUzImKBDQEKZkOPvUYCFMyIiAU2BCiYDT32GglQMCMiFtgQoGA29NhrJPAP+6FLVA6YHhsAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-6"
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "B")))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 221,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABG9JREFUeF7t3N1rHGUUBvDn7G5jQbR+ZZJKETEtJJuCIhVBECIiQq9ERVrZ3RpBKlh6KSKFgCC1f4D0srbb3hQVrxSxQSMWoiCUkJ2UEvxAwSYrXVuokM3uHB28aFl3szM7M/By9tmb3Jx5ec95fjuBzLwR8MMJZDgByXBtLs0JgMCIINMJEFim4+XiBEYDmU6AwDIdLxcnMBrIdAIElul4uTiB0UCmEyCwTMfLxQmMBjKdAIFlOl4uTmAAquvF1X9/TETioGhC8DeABhQ/K3AFOV0obLYvvPrglT8jrTFERQQWF1gvHIoNAKdbgrlZz786RIa2bJXA0gJ2a8xXReXl0ljtIpGBD7tDBLF+RUZT02i1g8dnd17+JVq53SrewbIBBoF+WvJWXrJLJ1pnBNYf2OcA/rg1TrkTCB6Cyj4IRrYY86YGhV2V8aX1aFHYrCKwfsAk90x5dPmbzvhPNR67p9BsfgDB4V40gkCfOzS+csEmnWhdEdiAwMLxqkLO1qd+AGRft3EL5LWSVzsdLQqbVQSWAFhI4sx68bgA7/Tg8XrZ80/ZpBOtKwJLCOxsffqEqr7dbdwB8PQhz/8uWhQ2qwgsIbDqWnERgic7eaji2nYPO18Rv2mTTrSuCCwBsDNrxTdFcLLbqFVkrjJaey9aDHarCKwPMBU92G7pYkggLyoq2+7KS3tKVQ5A8EIPGouN682Zo3tWw8dHQ/0hsH53sJg8BPhyc9vIgdl7L/0V81KT5QSWFjDFPCAny2O1T0xKGbApAksLGPCTqs4jp+cqo5cXBszD3GUElh6w23Fc1FzujcoDyyvmxMRsiMCyARbGcF0DPF8Z97+PmYmpcgLrB6zjWeTXOlOo36jf3dzEBAJ9VoG3AOzqoeJ3DQqTlfGlm6bUxGiGwGIC65zt+WuP7Nhobf8KwBNd/x4GOVLxah/GyMRUKYElBBZqqK7tfQoS9HqD9Yuy5+83pSZGMwSWArDzivxGvRg+Esr9b/aKX8tj/sMxMjFVSmApAJtT5HbXp5qA5LvoaJQ9/z5TamI0Q2ApAKuuTT8K0Us95r5a9vw9MTIxVUpgCYGFLx2eq099rJAXe8hYKHv+jCk1MZohsATAquvTuwXBiS1whYc/jpW8lfdjZGKqlMD6AQM6Dn1oASo7VDApwGQfDUGrHUwM8/E1AusPbOA7igDHS57/7sALGLiQwLICppi/w8N+vtFq4FuStIW0T3YL8NHIKA4PO64wF97B0ruDKYBvA+DYsB/0uP0LT2CDAQv/fdON/05865JAfsznc58dvH/5t6R3U2vXE5i1RB3rh8AcC8TadgjMWqKO9UNgjgVibTsEZi1Rx/ohMMcCsbYdArOWqGP9EJhjgVjbDoFZS9SxfgjMsUCsbYfArCXqWD8E5lgg1rZDYNYSdawfAnMsEGvbITBriTrWD4E5Foi17RCYtUQd64fAHAvE2nYIzFqijvVDYI4FYm07BGYtUcf6ITDHArG2HQKzlqhj/RCYY4FY284/kJBhVNHZlPgAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-7"
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "C")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 261,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABVlJREFUeF7tnF1sU3UYxp/3lI8RjQm4doIIUfxgp4AfBBOiJBJiMMYrP2ai68ZiRIlR8cJEjaiLIQYvJHrBjca4bkNFMFzojYnBTxIEEkNouyghBCKupxPBsDnI6Xm1OJIFe1jfdr1Yz9PL7nne5P97f+u6s7MK+CCBOhKQOs7maBIABaMEdSVAweqKl8MpGB2oKwEKVle8HE7B6EBdCVCwuuLlcApGB+pKgILVFS+HUzA6UFcCFMyAt//00tn+qL/cickiUcwOABHBKUUwUDw7uq/r+mOjhnGRiFKwCdacHlx2BZziOlFNQbACgBNSGRaRz31ft6ybm81Ewp4KDknBQiC9rnAWFZIbBNoN4OoKWF6M+BDZqsVYd8c1h4YNvYaMUrAya00PLkvA8T8RYHUNW/8VkPtTicyRGmZM+SoFu2SFPafcBY6PrwHcOAnbHfKLwYquuQPHJmHWlBxBwcatbceJ+bPOzbxqH4Clk7JNRX97IpsSgU7KvCk4hIKNW1qv1/oRIJ0V7HFYFaVXpWERzAcw79KOAnua4rivTbLnK5jXsBEKNrba3nzyIYjuvOymFVmFs+n0X6NfPnfTkXMXs/2ee1sAvAygrfScKjJN00fvaptz9EzDmlPhwSjYf0JIX8E9BGBJGDcFPmyKY8PlXpF6Pbck2OZgGtZ0zsker3AHDR2jYAAmevUS4LPH49lHK3kvtUfvmbZavvEb2hrD4ShYSTDP/Q7AqhBuheB80No5f+APA1dGxwhEXrDt+SUtRQlOhl2hF+ir7YncZhpTHYHICzb2vunTEHyBD1zblcgOVoeXLQpWSL4N1RfLqaDQQx2J3K3UpHoCkResz2vdpZAHywqm+n5HS2599XjZpGCeu1eBlWVVUHSnWrJvUJPqCUResF7vwvWvkD8N6cZUIvdu9XjZpGB5NwOBW14FClbrt0jkBUt77gEBlpcFKfJaKp55s1bIUe5HXrBeL/kVoPeWl0C2pRKZZ6IsSK1np2Ce+wGAJ0JA/phKZO+uFXKU+5EXLF1IviCq74RIMDLiz4o/Ne/gSJQlqeXskResJ794pSPO3jCIoki1t2T7aoEc5W7kBduhiJ0ruL8DiIddzW+K5+5oExSjLEq1Z4+8YCVwaS+5VaAbwyAq8EpHIvtWJZD7C4uX+xIMdjb/8lsl+UbPUDAAHxdumecHsaMQzAxZuEJ0fSqeK/1CEPpI55NrRXQHgOP+9Bmrumb/fLrRBZrofBRsjFBvIbkNqhsmALZLHNnS3pzZPz7X47m3O8CzALrGPf/tn2fOrx1/a/VEy2jEr1Owsa1uP3lzczE27SAECypYtKfACcGFz7gt/dNHIqSz88i/d8J2C4IKZjZkhIKNW2vfUHKFFvX7y/yorEIC3ZJK5F6qotgQFQp2yRrTnvuIAGkATZOw4bOBgzWdzdmfJmHWlBxBwcqsrWfIvdMJsBvA3Bq2mldxHuiIHz5Qw4wpX6VgISss3asfSHGTqjwJwQzTphW7Y3CefqzlcN7Ua8AwBZtgqf0nWxcGMTyvIg8LcF14XP8WyBdF4L3ORPaHBnSlqiNRMAO2/sGlNwTiL4NgoQBXBpDAERlS1QF/eGQ/P4Du/zApmEEwRu0EKJidGRsGAhTMAItROwEKZmfGhoEABTPAYtROgILZmbFhIEDBDLAYtROgYHZmbBgIUDADLEbtBCiYnRkbBgIUzACLUTsBCmZnxoaBAAUzwGLUToCC2ZmxYSBAwQywGLUToGB2ZmwYCFAwAyxG7QQomJ0ZGwYCFMwAi1E7AQpmZ8aGgQAFM8Bi1E6AgtmZsWEgQMEMsBi1E/gHsBpgVD70V0oAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-8"
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "D")))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    x: 301,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABAtJREFUeF7t3E9oFGcYx/Hfs7vVg4Jo3dmAIPQgJZNab6UHDyp6UbBYRFvdNyL2UAr1VtBbxYMognjyoIjZTa2IQutFtJYoNKeWoq0zeymFlkKdjX8gVPBf8sioVCOZyZqd57LvL7C3mQfe737y7mSZiYA/LGBYQAxnczQLgMCIwLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcO+BNdvhCQC7ZqDwGMC9F6/bCvxago6i/NZo/e3f/iGj7AIE1hmwHEN6GSgdqVejSyJQYptagMC6BvZ/0J9Lk+VPtvf9/ieRvSxAYMUBS6uOC2RXPYjOEdnzAgRWLLC0qYpIvV6NThMZgWGGi/z0wv4ugHlQLIRgbodoHkDlQ1eLbnR4fM8exh0sbwdT7HO1+Otn25JCvr2z/N0nExOrRPA5gBX5KvSXerX1ge8X/gTWIbDXMQ23wy9VcRiCOZnQVDa7WnS+Z7enDhZGYLMElrYdTsK6Cpo5na+5IF7VwfvQs4cQWBfAUhWNJPxGBNsyhChEl7hq69+eFTTDwgisS2DNZGAFRK9ndVZg52AQnyIwTwvk/hX5ykV+Xp5GEt4UwcC0x4gcc9XoC0/z8nuwIoA12wPHAf1sOkQKjAwG8RoC87RAEcAa7XC3AEczEv7hgniZp3m5gxUBrJn0D0JkKAPRbRfEVQLztEAhwMbCjVB8n5Hwvgvi+Z7m5Q5WBLBG8t7HIpNZX6iOuyBeQGCeFigCWLMd7gRwMiNh4oK4z9O83MEKAZb0fwWRQxmIbrogXk5gnhYoAlijPXBGoFszEl50Qbze07zcwYoA1kzCvyBYOj0iPeiC1h4C87RAt8CGbvWvLZXkh8x8qptcrfWdp3m5g3UDLL1HrDkW/ijA6mkBKR7OFSzeEsT/EZinBboBNtwO9yhwICfdWRfEWddmXhTn3RSzuJvirKL8aCzcr8DePCWisrJei0a9kJSxSALrEFj6cTh0KwwrFV2nKrsBvJMLR3HB1eKPfMaVrp3A8p8qevWhj0W5t0dPlXRPypX3+dQ3gc30VNGbb0CKR5OqG3b0ta68+cm9dwZ3sGKfixwriWzdXo1Geo/K7FZEYMUB+0nKlU/5sTgVIoF1CSy9Y1VUD7haK/vL1tn98vfEWQTWGbD0v+aMA7iTvgSIALk6UdGRHYviv3tCgtEivAdm1JVjXxQgMFIwLUBgpnk5nMBowLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcAKjAdMCBGaal8MJjAZMCxCYaV4OJzAaMC1AYKZ5OZzAaMC0AIGZ5uVwAqMB0wIEZpqXwwmMBkwLPAWYRmlUkDywWAAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-9"
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "E")))), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    x: 341,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAetJREFUeF7t2iFOQ0EYhdF5qgKBatkDa0CArEVUUTw7wsMikJBAWEHfHjDVpJAUwwL+TnoFj4OeuYGvhzEwNF8KBAsMwW3TCjTAIIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWgBwKJ5jQP2a+Dx4/xmP7SH45EYluvF5ul4e39zCTDAonIBAwywaAHAonm9YIABFi0AWDSvF6wAbGjt/au160M+iZN5266GcXfInSmeBawArLX2sl6Ml1MEkP6ZAAMsagwwwACLFgAsmtcLBhhg0QI1YOVvYb9vd7dn4335wsQPesEAixIHDDDAogUAi+b1ggEGWLQAYNG8XrAasNdZa8vKJzGfLz6vhufvytn/cAawGjB/i+z8bQAMsE46tWuAAVaT0nkKMMA66dSuAQZYTUrnKcAA66RTuwZYAVjXv0zPht3qdLOtfQzTPQVYAVjnx/+2XowXnXcncw0wwKKYAQMMsGgBwKJ5vWCAARYtAFg0rxcsmtc4YAxECwAWzWscMAaiBQCL5jUOGAPRAoBF8xoHjIFoAcCieY0DxkC0AGDRvMYBYyBaALBoXuOAMRAtAFg0r3HAGIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWiBH4qG1EV5clnEAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-10"
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "...")))), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    x: 381,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABDpJREFUeF7tl02IW1UYht9zk45WoUgzScZSF4I6k5taiqJScCO48Lf4UyvWJLVUEFzpQsFd60pduRFRxJ/JjEpQS8tYcSN1I6hURGeSOitrqzg3jlXqdNpMcj/JpgzpvZnZfIvv3jfbc86X9zzvw5mMAz8koEjAKc7maBIABaMEqgQomCpeDqdgdECVAAVTxcvhFIwOqBKgYKp4OZyC0QFVAhRMFS+HUzA6oEqAgqni5XAKRgdUCVAwVbwcTsHogCoBCqaKl8MpGB1QJUDBVPFyOAWjA6oEKJgqXg6nYHRAlQAFU8XL4RSMDqgSoGCqeDmcgtEBVQIUTBUvh1MwOqBKgIKp4uVwCkYHVAlQMFW8HE7B6IAqAQqmipfDKRgdUCVAwVTxcjgFowOqBFIl2Htnd1yTXelUHGQC8M6KCw9X860f1iLcEGQ67dJugbcTIj3x3PHq6NyMc5C1ztaD8g0O4eMCb4tIeEoyvel9o/O/r3UuKeupEazeLt0CcccAFFeVJxC8XC02D8YV2vi3vPniBTkGhzsG9nzRXTr/yP7rf70Qd3Yy8J9ywNsANqzasySQPbVCq58l8Z9UCNY4vXXjxSs2zQPYGtVoGOKhfWPNI1Fr9cD/BMCjUWsC93qtMPd81Np04O8Ige8BZCPW/3OZbKmS++lM0g1LhWBTC35FHOrxZcrxaqF11+D6R4vbruv2wt+GnFvuLi1vjnrF6oH/DoADsWcFB6vF5iEKlgAC9Xb5NYi8EHcVEfxdKzZzg+uTQek+B/f5MAQuDLdXxk7+PLinHvjfAbgt7qyDfFYptCJfxgQgv3SFdLxg7fKrIvLikOIWq4Xm6OD6VODfK8DQ30oSys21sdbsZXIu+N86h9uHfOen1UJzd5JkirpLKgSbDPzHHNCIf03wZaXQvGdw/cOFbcWeC/8A4MWcPXc+vzH3jDuxcvkLVn4DkGeHfOdLlULzFQqWAAJvya0brmov9/+MjUdcR8Rzd9dG576K+ZH/LoD9kRgEh+L+A623x8chmR8BXBlxdjHT7U7s3TL/VwLwDr1CKl6wPoHpoHRjCDcD4KZLRAQdQJ6rFltvxlGa/HP71fBWPnZwD6ze44D3R/LNp/c49GLPtssPOpEpAJtW7Qkg3sPV4uw3SZerf7/UCNa/bEP8kU4g94fOTTiRf7LZzMwTudnT6yn6g8C/0xPZCc/1PIRfP5k/eWJd585M5LwRbxeAayE41fF6Rw/kfzm3nrNJ2JMqwZJQmLU7UDBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi0uBbPWmLG8FMxYYdbiUjBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi3u/8iU/0XA7WPPAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-11"
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "G")))), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    x: 301,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABUNJREFUeF7tnF9oHFUUxr+TTRoatZba2VVIicWUNrOxFIMW31pBEKqoiAWb7LZSEEWo0of650ESi1QQxQfBBtFqdlckFH3JQ33Q+gcEWykEuhNrWwy2tu6sUbSlydrsHN20BZPObCbZXS6758xj9pxzOd/3u7N37t4JQS9VoIYKUA1ra2lVAAqYQlBTBRSwmsqrxRUwZaCmCihgNZVXiytgykBNFVDAaiqvFlfAlIGaKqCA1VReLa6AKQM1VUABCynv+/m1Ny1BSw9Q7GQPK5oILQxcZI6c8YDRHbHjp0OWEhWmgJWxe9i1b5wCbSd42wBsBChSJvwkmN9rJXp3a9S5KIqiMs0qYD7iDHJPS5t76XkQvQxg+QJhOcvc9FwydvzTBeY1ZLgCNsfWD3Pdd0TIGwZwV0WOMzJ//v3Pzl1rThUqqlPnyQrY/wzM5Nf1eNx0CMDKqvjK+KIv6txPBK5KvTosooBdNS09sb6di9PHAFhV8pGJqK/Pyn5cpXp1WUYBAzDM9pIpF98S4Z75XeRJgH4h4A8GbgF4FUBL5+YR8FJf1Hl9/nqNHaGAARhy7X0EvFjeav4BjNemL00eenL1+NS12OEz7UsLrcseAvAqgLUzf2cMJmLO042NTrjuxAM29Nv6KDVN/wygLVAyRv+pqLN3gOAFxcw8eean3gbQ0WplH95KKIazoLGjxAOWytlvgrC7DFwDiZjTHxaDw7ypeTN9NR02vtHjRAM2eK6nra150gVwQ4DRR1st5169Gy1+GogGLJWLPwbig0HyMdMDyVj288XLq5miAUu7Xe8w6NkADE73Wc4ayXtY1ZgeogEbytnfB21NMGN/MuY8Uw2RJdcQDVjKtX/HzF7W9RczJ5OxsZRkOKrRu1jASpurhTwCfydsIrqv18oe9hM5lbPHQegIZYDwPTG5gP0VX1Eo8ETw9gRtSMSyowpYqGkUGCQWsA/Od1otkSWlLQr/ixWwytC6ki0WsNJhwgJwIZgvb1PS+vFrvYNVhplYwJhBadeeBKHVd5FP/ETSGvtEAVPAFq1AyrVPAuj0LUD0RsLK7vEFzO06CtCqWZ8xlvvCqov8RftT94mpnP0ZCI/4b1PgSDLmbAzbZMqNjwC85bp4BSyshI0Xl3LjLwAceGarWET3jtucbJjOFTB/lcSuwUpypCfiNhe5HEAHE1HncQUsjAIKmK8CKdc+AuDuIAmJqDfMsWe9gylg/oDlu7aAaaTMHC2d7XoqEXUOlJvHCpgCFsjHfHexq4nfeB7emo4Uv9xpnZi1f5bJxzd7zEMA2nWRP1sB0Wuwa1JkXHuDB/7O7+UNHyovAzjLjDxd2UNbDWBZIL36FLn4BVwjZabz8W3MnKl6TwpY1SWt24JDua49RLTvvzeEmqrWBNErCSu7t2r16qyQfkXOMSyd736Q2UsDuLkyL3mSmXYnY87+yurUd7YC5uNf5lxXBzdTP4MT8/xHHZ9sLr2ulmbPG0jeeqL0OpzoSwErY3/KjXcyeBcBj/o+Ic7OHWXQSATeR73RsdJvnHpJPq6zUPcPnF93e6Q5cicxl06yzjw1EnDBIxpnunxs+8qffl1oTQnxegeT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEeFTCD4ksYWgGT4LLBHhUwg+JLGFoBk+CywR4VMIPiSxhaAZPgssEe/wWSB5ZUDjwpdQAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-12"
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "H")))), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    x: 341,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAglJREFUeF7t27FNA2EMhuH/psgO0LAHK5CKEVgA9qCDGhpmyRBZ4pDS0CQkxf9ZSvykPtny61e2dacsww+BIIElGFtoBAbBSBAlQLAoXsEJxoEoAYJF8QpOMA5ECRAsildwgnEgSoBgUbyCE4wDUQIEi+IVvLVgH/u79zHG81EN1vG23exeL1HkY3//M8b6eOzZZR3bp83u85I4t/gMwQgW9ZpgBCNYioAVmSL7F9cEM8GilhGMYARLEbAiU2StyAMBghEsSoBgUbyH4G4wN1jUMoIRjGApAlZkiqwj//yRP4m9b5GTQF5jmH8n2KSCCDYJ5DWGIVi+a478U0f+JPYm2CSQ1xjGBMt3zQQzwaKWEey0YN/LOr4uob8u42WM8XDsWSvyEoI3+oz3YPnGmmDe5EctIxjBCJYiYEWmyPpUdP5Tkb+tTbHPirQip4h0KgjBCEawFAE3WIqsG8wNlnfrkMGKtCKjqhGMYARLEXCDpci6wdxgebfcYEWMW6dpfYO17nxR8QQrAt01DcG6dr6oboIVge6ahmBdO19UN8GKQHdNQ7CunS+qm2BFoLumIVjXzhfVTbAi0F3TEKxr54vqJlgR6K5pCNa180V1E6wIdNc0BOva+aK6CVYEumsagnXtfFHdBCsC3TUNwbp2vqhughWB7pqGYF07X1Q3wYpAd01DsK6dL6r7F0Zuc1RDhTQ1AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-13"
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 280,
    width: 80,
    height: 80,
    fill: "#ff8000",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #192740; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(25, 39, 64)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "D")))), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    x: 181,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABAFJREFUeF7t3E+IE3cYxvHnnS3tQUGUFjYRBA9mxNJ6kx6ETEQvChZF0RYRxB5Kod4Keqt4EEUQTx4UUUQRUbBeSq2SX6h7qoiC1Z1VCi01E3XtwqLgv+StUbGuZGZDMu8lvyfn5IX57mffnR1mIuCLBQwLiOFsjmYBEBgRmBYgMNO8HE5gNGBagMBM83I4gdGAaQECM83L4QRGA6YFCMw0L4cTGA2YFiAw07wc7j2wQhgdBrA1i4ICzwU6AcgEgHFVuRpAR6SFkbt33D9klF6AwLoAlg1ILwCyP4ndLwCU2KYWILC+gb0N+nuzNbTx/u1LfxLZ/wUILD9g7QU2qZCtjdidIbLXBQgsV2CvmqqIbKqPVk8SGYFhmpP89kn9vwBmAJgN4KMu0TwJVL64O1a93uX7B/Zt3GAZG0wEO+uj7sc3P30plqJQBRGAbwEsnkbFlSR2S3w/8Sew7oFN8VRcWP5eFfsA+TAVmsi6ZLR6dmDXUxcHRmA9Amu3LYTRJgDHMzrXkti1N563LwLrA9hrZOUTgHydIkifB82547d+S3wVRmB9AptbqixuiV5LA6SCLY1Rd5TAPC2Q9V/keyf5qYUKpegGBJ92foMcTOLqd57m5XWwXICF0SEA33RCJEC1HrtlBOZpgXyAVbYBeqBTQlXcaYy5BZ7m5QbLA9hwqbJZRI+lIBpPYvcJgXlaIA9gxbCyWqE/pSR8nMRupqd5ucHyAFZYWFkL1ZQLqjqZxLVZBOZpgTyAFcPyFoUc6ZhQcS8Zc8Oe5uUGywPYcFj+QSB7UxDdSGL3GYF5WiAfYNEpATakJPw5id1KT/Nyg+UBrBCW/wJkXsfLFMCeRuy2E5inBfoFVlwQLdcAv6blE8Wa+pg752lebrA+gUkxjC4pUEkB9PTFED5+cNM9IjBPC/QDrFCKtkOwO3V7QU/X41rauZkXxXk3RU93U6wfKpTGd0F0R5YSgSytx9URLySlHCSBdQ9MhhdVFklTV7y8T38bgPlZcBR6vhHXvvQZV/vYCSz7qaJ3HvrQOZm3R0+VNBE08Tmf+iaw6Z4q6mEB6TNpyar6bXexhw8P3Ee4wfJ9LvKBQjc04lp14KT0eEAElh+wy0ETX/HP4lSJBNYnsPYdqwh0d/1WLfVia4+//APxMQLrDlj7W3MmAX0IyENR/NEK4CT4oJrcvPj3QEgwOgjvgRl15dg3BQiMFEwLEJhpXg4nMBowLUBgpnk5nMBowLQAgZnm5XACowHTAgRmmpfDCYwGTAsQmGleDicwGjAtQGCmeTmcwGjAtACBmeblcAKjAdMCBGaal8MJjAZMCxCYaV4OJzAaMC1AYKZ5OZzAaMC0AIGZ5uVwAqMB0wL/AbIeWFSV+Go/AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-14"
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "E")))), _image0 || (_image0 = /*#__PURE__*/React.createElement("image", {
    x: 221,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAetJREFUeF7t2iFOQ0EYhdF5qgKBatkDa0CArEVUUTw7wsMikJBAWEHfHjDVpJAUwwL+TnoFj4OeuYGvhzEwNF8KBAsMwW3TCjTAIIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWgBwKJ5jQP2a+Dx4/xmP7SH45EYluvF5ul4e39zCTDAonIBAwywaAHAonm9YIABFi0AWDSvF6wAbGjt/au160M+iZN5266GcXfInSmeBawArLX2sl6Ml1MEkP6ZAAMsagwwwACLFgAsmtcLBhhg0QI1YOVvYb9vd7dn4335wsQPesEAixIHDDDAogUAi+b1ggEGWLQAYNG8XrAasNdZa8vKJzGfLz6vhufvytn/cAawGjB/i+z8bQAMsE46tWuAAVaT0nkKMMA66dSuAQZYTUrnKcAA66RTuwZYAVjXv0zPht3qdLOtfQzTPQVYAVjnx/+2XowXnXcncw0wwKKYAQMMsGgBwKJ5vWCAARYtAFg0rxcsmtc4YAxECwAWzWscMAaiBQCL5jUOGAPRAoBF8xoHjIFoAcCieY0DxkC0AGDRvMYBYyBaALBoXuOAMRAtAFg0r3HAGIgWACya1zhgDEQLABbNaxwwBqIFAIvmNQ4YA9ECgEXzGgeMgWiBH4qG1EV5clnEAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-15"
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "F")))), _image1 || (_image1 = /*#__PURE__*/React.createElement("image", {
    x: 261,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAAgdJREFUeF7t2TFKnGEUheHvVyGVXRT7dNlF1iCkU9ybG0nlAiRMlQ1ESGfrTCBVyjMHb+HwWN97wfd/+JrZlj8FBgtsg7edVmABBsFoAcBG8zoOGAOjBQAbzes4YAyMFgBsNK/jgDEwWgCw0byOA8bAaAHARvM6Dth/Bh5fvv5aa315JxZ/7q53n9/p1oc9Axhgo3gBAwyw0QKAjeb1ggEG2GgBwEbzesFCYIfD2e3btn9Kv8b5/mJ/f/P8ks6f6hxgIbC1nX27u/r541QhTP1fgAE2ZevfXcAAA2y0AGCjeb1ggAE2WgCw0bxesBTYEZ/h01qX3693r0esnOwoYICN4gYMMMBGCwA2mtcLBhhgowUAG83rBQuBHfNj98PV7ve2rcPol/sgxwELgfmxuxMNGGCdnHALMMBCKt0YYIB1csItwAALqXRjgAHWyQm3AAMspNKNAQZYJyfcAgywkEo3BhhgnZxwCzDAQirdGGCAdXLCLcDCUMa6AoB13WyFBQALQxnrCgDWdbMVFgAsDGWsKwBY181WWACwMJSxrgBgXTdbYQHAwlDGugKAdd1shQUAC0MZ6woA1nWzFRYALAxlrCsAWNfNVlgAsDCUsa4AYF03W2EBwMJQxroCgHXdbIUFAAtDGesKANZ1sxUWACwMZawrAFjXzVZYALAwlLGuAGBdN1thgb96BK1FK1NE8AAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-16"
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "...")))), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    x: 381,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABDpJREFUeF7tl02IW1UYht9zk45WoUgzScZSF4I6k5taiqJScCO48Lf4UyvWJLVUEFzpQsFd60pduRFRxJ/JjEpQS8tYcSN1I6hURGeSOitrqzg3jlXqdNpMcj/JpgzpvZnZfIvv3jfbc86X9zzvw5mMAz8koEjAKc7maBIABaMEqgQomCpeDqdgdECVAAVTxcvhFIwOqBKgYKp4OZyC0QFVAhRMFS+HUzA6oEqAgqni5XAKRgdUCVAwVbwcTsHogCoBCqaKl8MpGB1QJUDBVPFyOAWjA6oEKJgqXg6nYHRAlQAFU8XL4RSMDqgSoGCqeDmcgtEBVQIUTBUvh1MwOqBKgIKp4uVwCkYHVAlQMFW8HE7B6IAqAQqmipfDKRgdUCVAwVTxcjgFowOqBFIl2Htnd1yTXelUHGQC8M6KCw9X860f1iLcEGQ67dJugbcTIj3x3PHq6NyMc5C1ztaD8g0O4eMCb4tIeEoyvel9o/O/r3UuKeupEazeLt0CcccAFFeVJxC8XC02D8YV2vi3vPniBTkGhzsG9nzRXTr/yP7rf70Qd3Yy8J9ywNsANqzasySQPbVCq58l8Z9UCNY4vXXjxSs2zQPYGtVoGOKhfWPNI1Fr9cD/BMCjUWsC93qtMPd81Np04O8Ige8BZCPW/3OZbKmS++lM0g1LhWBTC35FHOrxZcrxaqF11+D6R4vbruv2wt+GnFvuLi1vjnrF6oH/DoADsWcFB6vF5iEKlgAC9Xb5NYi8EHcVEfxdKzZzg+uTQek+B/f5MAQuDLdXxk7+PLinHvjfAbgt7qyDfFYptCJfxgQgv3SFdLxg7fKrIvLikOIWq4Xm6OD6VODfK8DQ30oSys21sdbsZXIu+N86h9uHfOen1UJzd5JkirpLKgSbDPzHHNCIf03wZaXQvGdw/cOFbcWeC/8A4MWcPXc+vzH3jDuxcvkLVn4DkGeHfOdLlULzFQqWAAJvya0brmov9/+MjUdcR8Rzd9dG576K+ZH/LoD9kRgEh+L+A623x8chmR8BXBlxdjHT7U7s3TL/VwLwDr1CKl6wPoHpoHRjCDcD4KZLRAQdQJ6rFltvxlGa/HP71fBWPnZwD6ze44D3R/LNp/c49GLPtssPOpEpAJtW7Qkg3sPV4uw3SZerf7/UCNa/bEP8kU4g94fOTTiRf7LZzMwTudnT6yn6g8C/0xPZCc/1PIRfP5k/eWJd585M5LwRbxeAayE41fF6Rw/kfzm3nrNJ2JMqwZJQmLU7UDBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi0uBbPWmLG8FMxYYdbiUjBrjRnLS8GMFWYtLgWz1pixvBTMWGHW4lIwa40Zy0vBjBVmLS4Fs9aYsbwUzFhh1uJSMGuNGctLwYwVZi3u/8iU/0XA7WPPAAAAAElFTkSuQmCC"
  })))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 400 220 L 400 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 394.67 239.53 L 400 255.53 L 405.33 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-18"
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "A")))), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    x: 61,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABL5JREFUeF7t20uIHFUUBuD/9CQZUBeO2lWJGkEZjFM9oBhdKUFQMXHra5G5bSKiQRe60IWIxhduFATFRxYS6BoVRrc+QV3ElSjGmK4MBMGEBOzqiKKIGmf6aM1MYLr71mNo7ib372Xfe89Q//2oqqnTJeCHCThMQBzWZmkmAAIjAqcJEJjTeFmcwGjAaQIE5jReFicwGnCaAIE5jZfFCYwGnCZAYE7jZXECowGnCRCY03hZnMAKDLQ60R4RvFnERER2ztTb75KSPQECK5ARp9FHAHaU4JkzQXIPgRHYmgzMpdF5/yhOQTBesvCP8TouuluS02v6A55M5hksZ6Nn08adCn2/igNV2d4M259WmevbHALL2fG4G8VQzFQDIW+YoP1wtbl+zSIwy37PKcb+TqNUBBf0DSuOQ3CZZckJEySb/aJT7WgJzJJT3J2+Cdr7cnBIoU8JJDtTbRwcq0nvup31+W+rxe7PLAKz7HUrbbwi0EcHh3o9vXWsJg8ocNfQMtXnTXjkaX/oVDtSArOdwdLoRwBXDAz1ZOz0hC5uaAJ4zbLsexMk11SL3Z9ZBDaw162fp6alJj8MXR4V7WaYTMedxtUQPWgjsrDYu3z3pvmf/OFTfqQENpDRbDr1pEJesET3tgmS+/cqapPd6BcA5w/fo+GRZpC8Wh67PzMIbGCv4zT6GsD1FgL3mSDZn30fp9GHAG4fvg/DFyZMbvaHT/mREtiqjOLu1CaonASG37Za1NrkrvBwdm+GVho9IcCLlngXFtZvqO+eOPhbefR+zCCwPmDRg1C8Zdn6kyZILj3z/WyncYOKfmUjwuZ3fyoEthpYTnNbROKZejv773Hps0+3rj+n+9evAM61IGPze1UoBLYSRmFzW/VeEx5prcYUp9HHALZbgLH5TWDDLIqa2zK2bvPMhYdO9AHrRI9B8JL1Mqm122bCw5/5cZdVfJQ8g63kM9tttFTVWOI6aoLkysHv3+letbWntW/s8bL5fSYXAgOQ29zOUlLsM2GyZxDSyvOwUwAmLMjY/F4JhcCy51o5ze1RLnFsfi+nR2BLz7Xsze1RgKniuWaY7B2lxtmwlsCWn8zbmtuj7i+b3zyDAXnN7VF1ZevZ/OYlEgXN7ZGNKdj89v4SWdDcVoXMlSkT6CUAbrTOU3xuwuSWshpn87jXwIqa2wC+M0Fybdnmx2ljEtCjOfO8b357Diy3uZ3dPLxs6snjZcCy8bgTHct5GQS+N7/9Blb45rbsMEH7kyrAZtNovwK7cuZ63fz2FljJm9v/am/dRHPjoT+rAGt1poyI9DXDV637fbyOuq9vfnsLLO407oDoBzmADpgg2VYFVzbnve6Wixd0LPuhovUjHje/vQVW0NzO+o/PmDB5tiqwpfuwNJr/39qWHGLevvntJbDC5vaykG0mSA6sDVjjdUAfylnjbfPbS2BrgcO5oyVAYKPlx9UlCRAYiThNgMCcxsviBEYDThMgMKfxsjiB0YDTBAjMabwsTmA04DQBAnMaL4sTGA04TYDAnMbL4gRGA04TIDCn8bI4gdGA0wQIzGm8LE5gNOA0AQJzGi+LExgNOE2AwJzGy+IERgNOEyAwp/GyOIHRgNMECMxpvCz+H6mHYFRTt/V9AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-19"
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 101
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "B")))), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    x: 101,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABG9JREFUeF7t3N1rHGUUBvDn7G5jQbR+ZZJKETEtJJuCIhVBECIiQq9ERVrZ3RpBKlh6KSKFgCC1f4D0srbb3hQVrxSxQSMWoiCUkJ2UEvxAwSYrXVuokM3uHB28aFl3szM7M/By9tmb3Jx5ec95fjuBzLwR8MMJZDgByXBtLs0JgMCIINMJEFim4+XiBEYDmU6AwDIdLxcnMBrIdAIElul4uTiB0UCmEyCwTMfLxQmMBjKdAIFlOl4uTmAAquvF1X9/TETioGhC8DeABhQ/K3AFOV0obLYvvPrglT8jrTFERQQWF1gvHIoNAKdbgrlZz786RIa2bJXA0gJ2a8xXReXl0ljtIpGBD7tDBLF+RUZT02i1g8dnd17+JVq53SrewbIBBoF+WvJWXrJLJ1pnBNYf2OcA/rg1TrkTCB6Cyj4IRrYY86YGhV2V8aX1aFHYrCKwfsAk90x5dPmbzvhPNR67p9BsfgDB4V40gkCfOzS+csEmnWhdEdiAwMLxqkLO1qd+AGRft3EL5LWSVzsdLQqbVQSWAFhI4sx68bgA7/Tg8XrZ80/ZpBOtKwJLCOxsffqEqr7dbdwB8PQhz/8uWhQ2qwgsIbDqWnERgic7eaji2nYPO18Rv2mTTrSuCCwBsDNrxTdFcLLbqFVkrjJaey9aDHarCKwPMBU92G7pYkggLyoq2+7KS3tKVQ5A8EIPGouN682Zo3tWw8dHQ/0hsH53sJg8BPhyc9vIgdl7L/0V81KT5QSWFjDFPCAny2O1T0xKGbApAksLGPCTqs4jp+cqo5cXBszD3GUElh6w23Fc1FzujcoDyyvmxMRsiMCyARbGcF0DPF8Z97+PmYmpcgLrB6zjWeTXOlOo36jf3dzEBAJ9VoG3AOzqoeJ3DQqTlfGlm6bUxGiGwGIC65zt+WuP7Nhobf8KwBNd/x4GOVLxah/GyMRUKYElBBZqqK7tfQoS9HqD9Yuy5+83pSZGMwSWArDzivxGvRg+Esr9b/aKX8tj/sMxMjFVSmApAJtT5HbXp5qA5LvoaJQ9/z5TamI0Q2ApAKuuTT8K0Us95r5a9vw9MTIxVUpgCYGFLx2eq099rJAXe8hYKHv+jCk1MZohsATAquvTuwXBiS1whYc/jpW8lfdjZGKqlMD6AQM6Dn1oASo7VDApwGQfDUGrHUwM8/E1AusPbOA7igDHS57/7sALGLiQwLICppi/w8N+vtFq4FuStIW0T3YL8NHIKA4PO64wF97B0ruDKYBvA+DYsB/0uP0LT2CDAQv/fdON/05865JAfsznc58dvH/5t6R3U2vXE5i1RB3rh8AcC8TadgjMWqKO9UNgjgVibTsEZi1Rx/ohMMcCsbYdArOWqGP9EJhjgVjbDoFZS9SxfgjMsUCsbYfArCXqWD8E5lgg1rZDYNYSdawfAnMsEGvbITBriTrWD4E5Foi17RCYtUQd64fAHAvE2nYIzFqijvVDYI4FYm07BGYtUcf6ITDHArG2HQKzlqhj/RCYY4FY284/kJBhVNHZlPgAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-20"
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 280,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 160,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "C")))), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    x: 141,
    y: 153.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABVlJREFUeF7tnF1sU3UYxp/3lI8RjQm4doIIUfxgp4AfBBOiJBJiMMYrP2ai68ZiRIlR8cJEjaiLIQYvJHrBjca4bkNFMFzojYnBTxIEEkNouyghBCKupxPBsDnI6Xm1OJIFe1jfdr1Yz9PL7nne5P97f+u6s7MK+CCBOhKQOs7maBIABaMEdSVAweqKl8MpGB2oKwEKVle8HE7B6EBdCVCwuuLlcApGB+pKgILVFS+HUzA6UFcCFMyAt//00tn+qL/cickiUcwOABHBKUUwUDw7uq/r+mOjhnGRiFKwCdacHlx2BZziOlFNQbACgBNSGRaRz31ft6ybm81Ewp4KDknBQiC9rnAWFZIbBNoN4OoKWF6M+BDZqsVYd8c1h4YNvYaMUrAya00PLkvA8T8RYHUNW/8VkPtTicyRGmZM+SoFu2SFPafcBY6PrwHcOAnbHfKLwYquuQPHJmHWlBxBwcatbceJ+bPOzbxqH4Clk7JNRX97IpsSgU7KvCk4hIKNW1qv1/oRIJ0V7HFYFaVXpWERzAcw79KOAnua4rivTbLnK5jXsBEKNrba3nzyIYjuvOymFVmFs+n0X6NfPnfTkXMXs/2ee1sAvAygrfScKjJN00fvaptz9EzDmlPhwSjYf0JIX8E9BGBJGDcFPmyKY8PlXpF6Pbck2OZgGtZ0zsker3AHDR2jYAAmevUS4LPH49lHK3kvtUfvmbZavvEb2hrD4ShYSTDP/Q7AqhBuheB80No5f+APA1dGxwhEXrDt+SUtRQlOhl2hF+ir7YncZhpTHYHICzb2vunTEHyBD1zblcgOVoeXLQpWSL4N1RfLqaDQQx2J3K3UpHoCkResz2vdpZAHywqm+n5HS2599XjZpGCeu1eBlWVVUHSnWrJvUJPqCUResF7vwvWvkD8N6cZUIvdu9XjZpGB5NwOBW14FClbrt0jkBUt77gEBlpcFKfJaKp55s1bIUe5HXrBeL/kVoPeWl0C2pRKZZ6IsSK1np2Ce+wGAJ0JA/phKZO+uFXKU+5EXLF1IviCq74RIMDLiz4o/Ne/gSJQlqeXskResJ794pSPO3jCIoki1t2T7aoEc5W7kBduhiJ0ruL8DiIddzW+K5+5oExSjLEq1Z4+8YCVwaS+5VaAbwyAq8EpHIvtWJZD7C4uX+xIMdjb/8lsl+UbPUDAAHxdumecHsaMQzAxZuEJ0fSqeK/1CEPpI55NrRXQHgOP+9Bmrumb/fLrRBZrofBRsjFBvIbkNqhsmALZLHNnS3pzZPz7X47m3O8CzALrGPf/tn2fOrx1/a/VEy2jEr1Owsa1uP3lzczE27SAECypYtKfACcGFz7gt/dNHIqSz88i/d8J2C4IKZjZkhIKNW2vfUHKFFvX7y/yorEIC3ZJK5F6qotgQFQp2yRrTnvuIAGkATZOw4bOBgzWdzdmfJmHWlBxBwcqsrWfIvdMJsBvA3Bq2mldxHuiIHz5Qw4wpX6VgISss3asfSHGTqjwJwQzTphW7Y3CefqzlcN7Ua8AwBZtgqf0nWxcGMTyvIg8LcF14XP8WyBdF4L3ORPaHBnSlqiNRMAO2/sGlNwTiL4NgoQBXBpDAERlS1QF/eGQ/P4Du/zApmEEwRu0EKJidGRsGAhTMAItROwEKZmfGhoEABTPAYtROgILZmbFhIEDBDLAYtROgYHZmbBgIUDADLEbtBCiYnRkbBgIUzACLUTsBCmZnxoaBAAUzwGLUToCC2ZmxYSBAwQywGLUToGB2ZmwYCFAwAyxG7QQomJ0ZGwYCFMwAi1E7AQpmZ8aGgQAFM8Bi1E6AgtmZsWEgQMEMsBi1E/gHsBpgVD70V0oAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-21"
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "X")))), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    x: 61,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-22"
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 101
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Y")))), _image15 || (_image15 = /*#__PURE__*/React.createElement("image", {
    x: 101,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAABIpJREFUeF7t2l1oHGUUBuD3bNJEEf9KdtYWSam02J3EgFjwQsGAF0IR8cLEH3a2JUiL+IeK1jvBG7FUEakgiBZ3V8GAiILghVAt6IVaQUtmq4b2ojV2Z6laKaVJNntkS4SQfrOZrD0XmX339jtzyPeehy87syPghwkYJiCGvdmaCYDAiMA0AQIzjZfNCYwGTBMgMNN42ZzAaMA0AQIzjZfNCYwGTBMgMNN42ZzAaMA0AQIzjZfNuxpYJfInFRiLYfBL4IXbkhAp1/zXIHjWVavAkaIXbk/SJ401XQ2sVB/eLtr8Pm6wonJnITf1TbvBH9LR3lP16BSAnKtOoA8VvOpHacSTZE9dDawVUDnKHwJkNCasg4EXTrQLslz374Pi05iaE/3ZcOu4YCHJMNJY0/XASlF+h0A+jxnuuX5gw7gXnosbfrnmfwLB/THrTwZeeCCNcJLuqeuBqULKkX9UBEPu71D6aNGrvutae++PLdl1PX2/A1jnWD9zvnHl4J6NR84nHUYa67oeWGuopcjfJcBB94D128Cr3uFaK9WHnhHV150wFS8Xc+FLaUSzmj0RGIBJ9ftm6zgBYKMrvJ5MT/6RgaPHlq+VI/9nALc4rrkwvzA3OLFhur6aYaSxlsAWp1qq5V8QkVedd4Ii+wrZqb1L1z6ob7utqZkfYk6vt4u58LE0glntnghsMbHJP2+6drZxxUkAVy8PUYGTQTbcJAL9b60S5Q8o5HFH4E1Abg68qenVDiON9QS2ZKqlmr9fBM85TyVpjhazx75urb3525b+667pmxHBekftx4EXPpBGLJ3sicCWpFY5M3KjLjSOu+4KVfWdYq66e/GmYEyASVfgzQxu3zkQftfJMNJ4DYEtm2qlPlRS1cAx7L//Ojt3w1Nbp2fLkd96brbDUXM48MK70gil0z0R2LLk3q8Nj2Sk+ZPzyz5krNnsOSyZRuvZV+8lNaL3Btlq3EPbTme0pq8jMMf4KpH/hQL3XLKk+Ewz8pXz2ZciLHjh8NIbgTUt4zL98QTmAnbav1sz+NKxNA/FDASbHGsTgRfGPKy9TNNag20ILGZo5cj/EcCtCWc605/F5nEJ5xLWd00ZgcUBqw89DNUPk0hQ1b3FXHVfktpuqyGwmIlffM8riqZj/h0uveqf/t4Lg+Prj5/tNjxJ9ktgbVIqR/mnAXmjbZCC/UE2fD5J2N1YQ2Btpl46PXKVZBqtn4+ujymbb2Yam3cO/Np6bMGPIwECW4FFu/ftWy9iBF74IGXFJ0BgK+ioRP6LCrziKhPoWwWv+gSBEVjHBgis4+guXsgTjCfY/xO0wtUERmAEZpoAgZnGyxOMwAjMNAECM42XJxiBEZhpAgRmGi9PMAIjMNMECMw0Xp5gpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJkBgpvGyOYHRgGkCBGYaL5sTGA2YJvAvj11NVPB81VAAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-23"
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 120,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 80,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Z")))), _image16 || (_image16 = /*#__PURE__*/React.createElement("image", {
    x: 141,
    y: 73.5,
    width: 38,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABECAYAAAB9Pvx1AAAAAXNSR0IArs4c6QAAA9BJREFUeF7t3E9Ik3EcBvDnty3TAktim1SHIkP2aqFBdCroz7mEpCidYRJCh24JHbp1SOieB2Hl7A8GSUG3kg6dAkFSX4skg4jYRmiBlrrtVwODEXv1fce+oPs9Xv2+D3uf72fv3N6hAn/YgGADSjCb0WwABEYEog0QmGi9DCcwGhBtgMBE62U4gdGAaAMEJlovwwmMBkQbIDDRehlOYDQg2gCBidbLcAIDEJvZUxnYuuVXqTlkgaOXQvabUudupDwCIzBRrwRGYAQm2gCBidbLK5gcsGWdzdR31H6YEd3gOg8nMCFgCupWe2jy5jrfv/jDI7CVimNJq9Zt2wGlFbR6AaC50DEaeD/3Y6np2v7pRbeZ5TpHYEVsNp6yuqHR53CozgLHTP944l83BOYR2KNU/c609tsAthU8VKm70eDkVY+xZTtOYB5XG09Yw1BocTjsq/IvWe07pn96jC3bcQLzsNrBZEOrhn7ieIjCmWjQfu4hsuxHCczlimOzTdsDy0tTAJzeDAxFQ/Z5l3HGjBGYy1XHk1Y/gC6H8Vm/9kUuhicSLuOMGSMwF6t+kGo4ntV6ZJXRy9GQHXMRZdwIga2x8qEvu6sWN1e/A1BXcFTjVTRsnzJOjssTJrA1ihpMNfRqrXscxhZ8Wf+BttrxTy77Nm6MwFZZ+f2k1ewD3gIIOFy9rkfD9h3j1Hg4YQJzKGtIw7+YsnK4DhUa0cBoZdA+ck4h46Fv40YJzGHlA4lIj1Kq1+HXaR9wuC1kjxknxuMJE1iBwu4lGvf5VWYcUFUOV6/bHSH7hseujRwnsAJrjyesl1A46SDiY3p+4WDn3s+/jRTj8aQJ7L/CBpKRLgWV+1C18MVL+U5EgxOvPfZs7DiB5a3+YaIxnFHZ3O2gmsIiVH80NHnFWC1FnDiB5ZUWT1q5G9mtDj1+S2+qsDprxuaK6NnYQwhsZfXxlHUaGs+cJGjtO9sRnnhqrJQiT5zA/t4DGvxeV60zFbkvEe5y+MtrJK3Q5rnj+YU5098MEBiAeMLqg0K3Z0BrHKCVvtARnHpc6tyNlGc8sJXbQaNA6f8hMoEJlLqRnl25xxpPRFqg1LDE4yYwAiMwiWdWXqbxL5G8gskKIzC+RIoKMx6YaLsML/07J3bKBvIb4BWMHkQbIDDRehlOYDQg2gCBidbLcAKjAdEGCEy0XoYTGA2INkBgovUynMBoQLQBAhOtl+EERgOiDRCYaL0MJzAaEG2AwETrZTiB0YBoAwQmWi/DCYwGRBsgMNF6GU5gNCDaAIGJ1stwAqMB0QYITLRehv8Bki/uRYI6BSwAAAAASUVORK5CYII="
  })))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 479.76 220 L 479.76 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 474.43 239.53 L 479.76 255.53 L 485.09 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 560 220 L 560 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 554.67 239.53 L 560 255.53 L 565.33 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 639.76 220 L 639.76 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 634.43 239.53 L 639.76 255.53 L 645.09 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 240 220 L 240 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.67 239.53 L 240 255.53 L 245.33 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 319.76 220 L 319.76 251.06",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 314.43 239.53 L 319.76 255.53 L 325.09 239.53",
    fill: "none",
    stroke: "#a3ea2a",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-29"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-30"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-31"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-32"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-33"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-34"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-35"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-36"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-37"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-38"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-39"
  })), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-40"
  })), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-41"
  })), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-42"
  })), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-43"
  })), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-44"
  })), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-45"
  })), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-46"
  })), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-47"
  })), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-48"
  })), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-49"
  })), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-50"
  })), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-51"
  })), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-52"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-53"
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 200,
    width: 160,
    height: 80,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(2)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 78,
      height: 1,
      paddingTop: 120,
      marginLeft: 432
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #A3EA2A; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "&quot",
      color: "rgb(163, 234, 42)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Encryption")))), _image17 || (_image17 = /*#__PURE__*/React.createElement("image", {
    x: 432,
    y: 111,
    width: 78,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATgAAABcCAYAAAD6bamSAAAAAXNSR0IArs4c6QAAGZ9JREFUeF7tXXucHEW1/k7PZjcEA4SkezYQngaS6QkBbuQhKAjKvUYUQTAaMj0h4BMvUbkieFXQe30ioiCi4AOyswGMouLjiorARUURvErI9CaQC/IQMj0JCTGv3ez0kZqdTWZ3u7uqZ2eS2UnVX/P71anH+arqm+qqc04RdNIIaAQ0Ai2KALWoXlotjYBGQCMATXB6EmgENAIti4AmuJYdWq2YRkAjoAlOzwGNgEagZRHQBNeyQ6sV0whoBDTB6TmgEdAItCwCmuBadmi1YhoBjYAmOD0HNAIagZZFQBNcyw6tVkwjoBHQBKfngEZAI9CyCGiCa9mh1YppBDQCmuD0HNAIaARaFgFNcC07tFqxsYZA97q0zf28GIRTAEwBsJFBjyQINy0w8/eNNX2aob+a4JphFHQf9ngEcp69CIxvgtAeCAbhGsd0L9vjgYoJgCa4mIBpcY1AvRFYWpw5x2fjTwCMqLqJ4WSSbne922/l+jTBtfLoat3GBAI5L70E4Kyss8z4UzbpniCT0/k7ERhBcMyg7xftvXcFSPMsd9OuaEe3oRFoZgS6vNSjBJot7SOj10m646VyWmAHAiMILuelpwP8xK7AqAOYqEluVyCt22hmBDTBNW50NME1DltdcwsikCuksgAdHqZaB+GauH/a+hO1cRNFE1zjsNU1tyACuYKdB8EOU60fmLrIctfEUb2rOOtVxP5DsksGZs5mkz25OHXv6bKa4Pb0GaD1j4VAzrM3A5hQT4ITdXUV7PcR8Q0AJULqvsGx3EtidVYLj3yTQZ/B6VmhEQhG4LbCrGSJ/MjdWS07uMHWBsxFEh8B+FQAJjM2GoSHfaKvZ838T/W4xEdA7+DiY6ZL7KEIdK9JncgG/SFK/dEQ3B4Ka0PV1gTXUHh15a2EQK6Yng/m2zTBjZ1R1QQ3dsZK93Q3I5Dz7P8E8FlNcLt5IGI0XzPBMfH8rNlzR4y2tKhGYEwjkPPS3wL4XZrgxs4wNjXB5Qrpo4n9vYLgJIO2LbDcvwbliagMKGE+g18LYCYYk0DYBqAAYDWYf8o87s5s53KvEUO15LmZk40O42T4OBYkbKZ4EgHtDGwC6DkCLy+14Z6F+7vPqLQv6ku00RFhsqV+fmLhtJXrhueLQ/F+8i8k8JsBsgGeCNBmBp4gxs+cpPsplfZ3pcyyFw/fd1tfx0FhbY5v73123v5PvlSdfxXDmL42NZeZ3gbGCUQ4BMB4cUgvxpvAvwcSP3CSKx4cjS65gn0PCK+vN8HdxHPG7V3YMkfWNxrftmrBfo+tl8lF5Yu2JhS3ngjQSQw+khhTKg7+m8B4BoQV/SX/vkVTV/5tNO2Iss2wfpub4Dx7JYAZIUBvcix3YnXe7etmHdRf8r8C4G3AyBviYfX8g0Efc8z8jUTg0Q6mcHFbWkyf64MvJvApEdf9g02JNh9g8q/Kmiv/N6r9rmLqncR0e4TMJY7l3jCYv4yR6CumrhD6AQh0u2Pgb1nLPSznpR4G6FVR7TPjtmzSXRAHI4U+g0Hfy1r5d1bXq1Du447lfm6wzJI19lsNA18CEPoHUFX/70CldznmqlUyXboLqYt9wlxiMkHl0EUmgH1k5aLyCfhlxnLfOFzmFs/ubANekNbNfI6T7PmxVC5AYGBt8BUAzwcwSVYHA38m5utXWz3dnyb4Mvmg/FwTrN+xTHCgRNtBmcnLnxPgdnn2BQR8FcC+cQaDga9lLXdxnDLDZXOePY8ZVxIhXVs99PPtpd5FF05dXQwqL1v0RHR1xsxfLsou8+xX9DLuAuF0CWndlU26Z+eK9nvLYXqi08b1L/VZi49Y3auqX86zvwtgUXQfjHOzyRU/jElwP3Is9223F2cc0M9ttwJ8hmqfKnJiJ39Z9R9CIOZe+g4CvyNm3ZHiu4Pglr2U3n9bLz5JzO8HoSOuPszIw6CP1WKmIiG4XbJ+xzTB+T6fsVeSHugtkjgbkUZjCBtcZrw/m3Rli3xE8TKZoNz2kF1I3ElUkX+KEvTmzOS8O7y8jODAfLuT7Dl/GdvtvUX8GigHTIxOjE+LT9TuddP34VK72D2EGq+KipjorDiTPOfZzwKYFtGJTf2bt5iLDvubIJwdSaYrA88mwBkf9D0AnTI1I/KH7HpHYN4CBNe1JjWLDLrr5f//UNcyZfyYv9Jh9Vw2j1BSLSMjuF2xfsc0wTHoszRwziZf0BGjwowXx4/bdvjws52ogVxSnHkksXEXiTO++qR+n/1TFiZXjrCzki16AL9zLPe13Z59HQNqu9Gqzx01X0he4lg9F6ioeusLdjqRwIoo2bDPXgVdVbqgIsPEfG4m2fOjVtzBdRXTb6EBk5ZXqIChIiN2oO3Aeaq+tjKC2xXrd0wTnMqgqMoQ+BMZqyfSBGCwrq41Mw4jI/FbAAeq1i+Ti2pfuugZT/vw5xtk/F7h7LHcFfZLh2c7Vz0lfi/1Uqf4oMhzQADrt5h7Jd9Lf94u06WrmP4wMV8bJef7OHthpyt2F0OSVFdZ4/HyX+ij0oyLzFX/aKUd3NJi+jTf57tDowPHw2iItCC5A03rzafR/f2yamQEJysfJz9s/WiC24niCsdyj5KBuuzZaXv1duwjdllHy2TV8/n+1WbP68MOcxUWvZhsTwI4UrHNlxzL3a9aNufZ4uBdUp7mOlb+blkb3Z59NwP/FiEXeqanoKus+Xj5jGudpPsfrUJwlQuL5ZVLkXhYKEoT8PmM5QqbwMi0KwkOQOD6rZngAHGzwrFvH4mMLw8eiDcZQGLzc4Rj5VdH9aurYF9DhBELQqZLRP463+g/euGUx/8eJtOARf9bx3KHfNbnvPTlAH8hWg/6tmPl3x0lc/0T0zsm7TtuPUCB5j3lsoRux3SdoHpGoesGZvydBm48kzHGY0sHkBz+2dU1Rs/gur3UnQwSVgSNTD6Ij3PMnv+LamQXE1zg+h0NwdUEIDO+nE26H1EpHBcgcQBNoK8zlf7IwAttSBzoMy5QvYAg8DszVo84vA5Mt609ambJLz0GoE2l/+KqHYSbfd/4zYS+Dc9vnzhpPPeVTmTG+0A4S9QR9qlWXf8oFr2wu/vhy3ZwjzBzPxuGScxHgWi5Y+b/u7qNyj+/uBiI0m1th+l2Rh005wqpM0D0qyh8iIy3ZMwVP6sTwf0CwOcdyxVHBuW01LOP8Qdu1IXTukq60LHcW6oFc0X7LOKqsEhENjMHknJ1OXGuZIADI1Uz8KRjucuGd6heZiI5zxbn0Q+oKAzGQwT+ooHEg71bNr3UMXHioaVS6R0gvjzyz2lH5Xy/Y/WcVk+Ca8T6bR2CY9zU0bfxw/MOem7rcNBznv01AP8uG3gCfSZj5T8ZJtddTHepTPKB8nTFajP/pbDPzm7PniuMLaPaG+xHjQR3Q/+49k8umvTXDTK9B/NzBVuYl5SJNyyRjzdkOt3fhOXnivaXwIj6A9vQYSI5j9y+0REcl0D0Acd0bwqqp2wLuNa+mxlvkOnPwH1Zy400q8kVUmeDKPBCorr+Wpzt60hwPwfwJrm+9L2t5ngn6Dx1iWcfawDiPHaIjWlQneTzqzOdPX8MnQvRdnBDizVo/bYCwfnEfEkm2XNj+KJLTQWT+ASMfGSHiHIZMx9oblL2Tmg3hDnFONkEIuBjGcuVfO7JatmZH5PgmECLMlZ+iXoLA5Ji1wJhQxeRmPHNbNJ9f8SkFuc/EWeZ0bexqroyMC9rud+P6uvS51OH+G0kwu9Lxoy3TjOT+0QdnDc7wXWvmz2NS/3CMyb6ISnG08xt6WznchHXLjBVbEqH7GhDRG9xLPfCURJcQ9fv2Cc4xk1O0n2fbDHnPPtxqbU748dO0j0nqC5Fg1hR9I+rTffkWq2/R7ergXDJ+ELWcoUHQ+wkdj29xbL92tSIwoXVpntAkH65YvmP5PlIggSfmbV6/id0ccm9NspF+8e1T1LZnSqfSTEd4yTzj4Yu1ibfwancXFd0i7T/EzKVeSC8iKZLJtGGaaZlhv0xKB0xNXj9jn2CA13nWPkPyVazws2eYId7naQb6GuY82yxWzhP1g4Ib3VM9ydSuRgCqrsaAE/1b95iDzeejdGU8Aj5PAFXRJUxwKcusHpGnPV0e+mFDL41oqzU1ERVV1WCyxVT7wILY+zoRMBFGcsV3heBqdl3cCrHC+LId3uprzPMY6Za8S4v/RkCf1yGG5NxXNZc8UjgpkDpE7Wx63ePIThFgvq9Y7mvCdxFefYzBIQ6gVfKrO8wXTOOtbdsAol81UUP5oudZM83VOoMk1nqpY7wQWK3G5rC3Nu6CvZSIpwfVpCB72Yt96KoulV1VSW4JWvt4w0f4r2D6MT4lJN0Pz1mCc6zxc45auctVHvUsdxjZFAMzLmZpxIb98tkifkDYcdDSjs4xQ1Kret3zyG4gt0NgsxhPJDgbnnq0PFte0/YIj3fAP/KsXqi7L9k8yUwX3XRJ/r7zfMPeHxtTY1UFcp5tjhkjvIO+XvGdA+qDlIggg10F20RrUU4pQcmZnpjNpn/5a4kuNueP3JKqa0t0Md3SD+Yv+Ikey4diwR30/NzJkxo2xp6prZTJ7rDsfLC2V6avvvCdHNcol0abSfKKqKuBFfj+q2Z4HZFPLhmAEjMhKVrjjrcN0r/L5sVBFyfsdwPyuTi5qsSnOquRtZ++Wk8ouhLCuI51XZQ3WtmHsWGIS4YwtK6aabVKbOAr7euA3Z57UP8XUM6GH1g3sRncLcWZr0yQX6k/WZZZ8I1juleJhv/wfxcwd4mc9CPijTTDOtXE9zQ0Q7cwSks3nItzPivbNK9SnUCqcrVe9HL2q14a4gb49DILMNdY3KeLcxwhDlOyO6Nv5VN9rxH1nYjdM15tgj3E327CCxzLDc0ekgzn8EtKcyabZAfekGyA3PJZ/jwsXl5TMXXwOSoMWNGOSpNkIwmOMlsbwaAyju4AcPRv8gWJ4iuHG5AKy2jINCIRS9rtqtgf4MIUbfTQ/4MZGckInLEws6ee6Tt1vkWtXK8MMI2cmQ/qMux8gvD+tfMBKc6P+P4Wwsccp4tXhCL9Aph8M+yVs9bNMHJZnZAfrMQXK44YwY4Ia7No1OIX6OsmCx/txDcwGPED4f3jUtGe5s5GGFWshiKHaY7VeXypd66Kp/BgW50rPwHxiLBicg2BhvSIJ5xTYhkb8BWsArd+TbD+tWfqENndOAnqvoiwZ2O5cpNSWSMNiy/3otetfkuL/UogWaHyQ8a28r+AGTGwdX111vXyqvxEUS9o/UhkYJHfK418RmcCGrZ28sjQtYP10HlFnuwTNea2XuT0R/ocja03vA/Bk1wkpXWDAANdjHn2SKkTmRsLeFLl7Xcg1UJRFWu3oteuV3PXkzAdaHyFSPNLi91EYG+HSZnEJ2+wMzfp9JuvXVVujARHSM63zHzoWHhm/kTVXQ/59nCJU8WzbocN1BlHHLF1L+A6c9SWcZlTtK9JkiuGdav3sEp7OAqE0iESDpRNuBk0PGZKXmVHYOsqh359V70qg2Xdwbb+PmIm7QnHMs9UhKePNTzIagf9dY1p2ZeAFBpZtRbDSpubEKfNiodON9cFenNMVzvevii5jxbGF5LyIu39m/eur+KIXjOS30QIBGwIDJFna1qghtLO7hC6loQfVg24LU80CKrs96LXtZedX7OS98eFZK9LWEc3F/yxeVBSCy56LOt4X2pp663rD9mv7btfU8rPBbjZUy3M+rxoa616dPJ59AgA4N6sGHY2SkreuJgXCeCE8FapTHaVKLXVP7QhZGvLBpLfx+V9g8KGFqpI+rRqApEap4Min9UI46Y9A5OcQdXjpLKfK/KxCXgTRnLFWF8pEkYyMpe9arnopd2aJjAkjWpNxgGiXceAhMTPkKMwE8UUSDMrSusvnrq2uXZ1xNwiYLOkTZwovzS4sw5PhuBLknV9asEARjen3oQXIyzRulnatca+wQyEBolpKr/dzuWOzcM3zG9gyPQBe3gOxUmT6jI5s1b+qO2y80A0GDnhQPytqK9moBDFXTeCDbmRr3D+Z3ijIntnPgcQONlQSTruegV+j5ERBBwrmg/Gao3ozfiE/aF1aY7LU7gAVVdAfr19lLvgjC/SvHsHxN9XUVfWdgfUcfAK16J0KCkO9ph/MRJum9VaXdQph4EJ+rKebZ4J1gaaZqAxRnLDbRZrMxL4dqWkulAoLdnrPwPWpLgZMqr5EcZCVYGbLdvcav16C6m383MN6voBmA7AdckqHRD9ZmMeIlrG3AeASLgZPnVKSb/dVFvo6ou+np5MgzXr6uYvpKYQ/00w/Co5UlGVV0rbW5k4EbD57swbrvrb59QYuqbbZAhgi/MUxonxkNO0pWerVbmo3BdCnVFG2yPiS7NmnnxPu9O3mPQzZjTFhSDrV4EV3kjVuXdVAb46o4O4+p5++ZfHOxkrjDrJJAv4uvNUsDu0YzpHhv19dEMG5SaP1EVAJCKjDWCE6+C71Xc+rjiLm5Qf2FFL2KSeczYnwivFK+uDwNnVYeJ2aMNAtkogqs8qC1eOjekg1olQEyvySTz4iEc5RST4JTrjSBhaVy5HQTg2eLYYcTDzSF1/4WIfs2+3wsyDgH4dAYuDYphVy+CE/3oKtgPEeF4JWAYfSAI+7mNAA6RPPM4pEqVZyQ1wUW4eVT+MZtqB1fu00BQSPEvKXP9UZpjO//iw6NZqC76RhFcZSziLG5R5LmM6R4sO18cDpKqrvHADZWOPEMaXqrbsy9k4Ds1tx3iC1pPgutemz6OS/xbmQ9pzTqIgoqf4ZrgxiDBVRa70o1VrEkkzrKM0tFBpgqqi76RBNftpc9jcGQE3Wp9GfTVrJWX3jrvRoJb30alWXFMOirnU8JHd+9YY7tT+AHHckfcTNaT4ERToybiCOUYWGkk+k7ITF4tdn2RSRPcGCW4qxjGdM++E4RAJ2PZwIfnBz/k0QwEt4zt9t4ixCG7eLVKmnz2Twp6xFpWUFVXWT2S/H4i45ywh2+iyuYKqctAdHWN7W/uMN19h7us1Zvgyn/CxfTVYFaOHKKozxqf/FMXmisj4wUO1qUJbowSnBjAMsmttb8oeWBFcd6UxfoZ9KGslR9x86e66Bu5gysvGkVbQDCeyVjuoXE/T0UbiroKou1QJdshg8DoJaJM1O1f1KBVwnmLeHknxxncQVmfjaMXJlcMCSvVCIIbIDn7veByhBfpOyJyXfgR3yidHfW85fA6NMGNYYIbHMxuL/UOBn15lK/cPwriC8PemVRc9MrvFMgnc7BE97q0zSXOy8rHeRpyeF2Kuj7KfukcMhLigRzpY91VbTzJPs7PdrryCL8RSoqb8F5APHsoM4QdWQvxux2zZ4hbW6MITjTeXUifzMQiynMcnKr7vZ2Bb5Y2b/moigdEdUFNcC1AcGJAyyF5XjHhYjA+KgsvUz0BxLupBuOrT1jubVG2YoqLvuEEV94VeLa4dQvxWhjQzjdwwsIp7p9kRBiUr6Qr42kn6R5avtVeu3UxMT4BYL+I9ooEvq699x/XBj0rWUs/RdsTvK0fBEE8M7mPch0BFw2NJDjRr8qRynwQrpSNXZUe/SDcwaXSldnOVU8p61cl2JQEV4siuswAAuLzZWshdVoiYZzhMx9HjFdi4KX1dgAvMniNAVrlM+4lonscKy+PwtpE4JZDYye2rgeV9QlLTzmWe3it3VYiOGCDY7mTBtsQfzDjJuw11wf9K1HZ3GESAS/5oB4ivm/9hr5fLj5idW+tfYoqt3TDUZO4t3QmE50JsLAfE3ZykwHeDtAmgJ8GDJeZ/9CWSNx//pTH5GG3GtHRSp3da1InwjDOZOZXM+FIKveXxwEkQp4/A+bHyDDu6+vv/bHK4zQN7Gpdqq6vqUNduqQraVYEujz77QSMeJm9ur9xgyoO11WR4PyM6bbVcsbXrNjqfjUGAU1wjcG1JWvNeamHAXpVhHLb+4GDF1muiARbU1IkOPRRaZ8wJ++aGtaFWhIBTXAtOaz1VyrnpS8H+AuSmiPfNVDplSrBNfrGWKWvWqb5EdAE1/xjtFt7KM4V+9amLmEu3xRHumoZwLELLFc4fNecNMHVDJ0uGICAJjg9LXYgUL4ZLG55kEHLibHhZfMAESPtdQAOUIDpp47lnqUgFymiCW60COry1QhogtPzYQcCMeKADUWN0UdtdGxmct4dLZya4EaLoC6vCU7PgUAEckX7UjDEp2isVM/3YDXBxYJeC0sQ0Ds4PUV2IJDzbBG88NyYkPyuw8Trw0I9xaxL1VVrlxg1x+27lm8+BDTBNd+Y7LYe5TxbPJYyVbkDDNfoSLxm8G1U5XIRgnoHVw8UdR2DCGiC03OhjEDXmhmHkZF4MgYcv+jooEx1RNgYZUNFNcHVA0VdhyY4PQeGIJAr2AtA6JbCwngGBj6XmeLe3AhPAk1w0hHQAjEQ0Du4GGC1suiStfbxho/3ADipErp6b4B7AVrHQAHAg8R87xZrws+D3hVoZWy0bmMXAU1wY3fsdM81AhoBCQKa4PQU0QhoBFoWAU1wLTu0WjGNgEZAE5yeAxoBjUDLIqAJrmWHViumEdAIaILTc0AjoBFoWQQ0wbXs0GrFNAIaAU1weg5oBDQCLYuAJriWHVqtmEZAI6AJTs8BjYBGoGUR0ATXskOrFdMIaAQ0wek5oBHQCLQsAprgWnZotWIaAY2AJjg9BzQCGoGWRUATXMsOrVZMI6AR0ASn54BGQCPQsghogmvZodWKaQQ0Aprg9BzQCGgEWhYBTXAtO7RaMY2ARuCfv7aoL6JZ8GgAAAAASUVORK5CYII="
  })))))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "T85KSdLNI5-jvUVYhxRm-54"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.0717e0c972c23cf364ea57469c3a73f4.svg";
export { ForwardRef as ReactComponent };